import { useEffect, useState } from "react";
import { Copy } from "lucide-react";
import { sounds } from "../../lib/sounds";

// RUN IT TWICE: two players all-in with board still to come. Both must say YES inside the window —
// a NO (or the clock running out) deals the rest of the board once, as normal.
export const RunItTwicePrompt = ({ offer, mySeat, serverNow, onRespond }) => {
  const [left, setLeft] = useState(null);
  const mine = offer.seats.includes(mySeat);
  const answered = offer.responded.includes(mySeat);
  const [sent, setSent] = useState(null); // optimistic: the buttons settle the moment you tap
  useEffect(() => { if (mine) sounds.turn(true); }, [mine]); // it's a decision on the clock: make sure it is heard
  useEffect(() => {
    const tick = () => setLeft(Math.max(0, Math.ceil((offer.deadline - serverNow()) / 1000)));
    tick();
    const id = setInterval(tick, 250);
    return () => clearInterval(id);
  }, [offer.deadline, serverNow]);
  const done = answered || sent != null;
  const waitingOn = offer.seats.filter((s) => !offer.responded.includes(s) && s !== mySeat).length;
  return (
    <div data-testid="run-it-twice-prompt" className="absolute left-1/2 -translate-x-1/2 top-[8%] z-40 w-max flex flex-col items-center gap-2 rise">
      <div className="flex items-center gap-3 rounded-2xl bg-slate-950/95 border-2 border-emerald-300/80 px-6 py-3 shadow-[0_0_40px_rgba(16,185,129,0.6)] animate-pulse">
        <Copy className="w-5 h-5 text-emerald-300" />
        <div className="flex flex-col leading-tight">
          <span className="font-display tracking-wider text-base text-emerald-50">RUN IT TWICE?</span>
          <span className="text-[11px] text-slate-400">Both players must agree</span>
        </div>
        {left != null && <span data-testid="rit-countdown" className={`font-mono text-sm rounded-full px-2.5 py-0.5 ${left <= 4 ? "bg-red-700 text-white" : "bg-black/60 text-emerald-200"}`}>{left}s</span>}
      </div>
      {mine && !done && (
        <div className="flex items-center gap-3">
          <button data-testid="rit-yes" onClick={() => { sounds.click(); setSent(true); onRespond(true); }}
            className="rounded-full px-8 py-2 text-sm font-display tracking-[0.2em] text-slate-900 bg-gradient-to-b from-emerald-300 to-emerald-500 border border-emerald-100/70 btn-lift">YES</button>
          <button data-testid="rit-no" onClick={() => { sounds.click(); setSent(false); onRespond(false); }}
            className="rounded-full px-8 py-2 text-sm font-display tracking-[0.2em] text-slate-100 bg-white/10 border border-white/20 hover:bg-red-500/30 btn-lift">NO</button>
        </div>
      )}
      {mine && done && (
        <div data-testid="rit-waiting" className="text-[11px] uppercase tracking-[0.25em] text-emerald-200/80">
          {sent === false ? "Running it once" : waitingOn > 0 ? "Waiting for your opponent…" : "Agreed"}
        </div>
      )}
      {!mine && <div data-testid="rit-spectating" className="text-[11px] uppercase tracking-[0.25em] text-slate-400">The all-in players are deciding</div>}
    </div>
  );
};
